'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _lodashLangClone = require('lodash/lang/clone');

var _lodashLangClone2 = _interopRequireDefault(_lodashLangClone);

var _lodashObjectMapValues = require('lodash/object/mapValues');

var _lodashObjectMapValues2 = _interopRequireDefault(_lodashObjectMapValues);

var _lodashObjectForOwn = require('lodash/object/forOwn');

var _lodashObjectForOwn2 = _interopRequireDefault(_lodashObjectForOwn);

var _MediaQueryListMock = require('./MediaQueryListMock');

var _MediaQueryListMock2 = _interopRequireDefault(_MediaQueryListMock);

exports['default'] = {

  create: function create() {
    var config = {};
    var createdMqls = {};

    function matchMediaMock(query) {

      var mql = createdMqls[query];

      if (!mql) {
        mql = new _MediaQueryListMock2['default'](query, function () {
          return config;
        });
        createdMqls[query] = mql;
      }

      return mql;
    }

    matchMediaMock.setConfig = function (newConfig) {

      if (!newConfig) {
        return;
      }

      var matchBeforeByQuery = _lodashObjectMapValues2['default'](createdMqls, 'matches');

      config = _lodashLangClone2['default'](newConfig) || {};

      _lodashObjectForOwn2['default'](createdMqls, function (mql, query) {

        if (mql.matches !== matchBeforeByQuery[query]) {
          mql.callListeners();
        }
      });
    };

    return matchMediaMock;
  }
};
module.exports = exports['default'];
//# sourceMappingURL=MatchMediaMock.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/match-media-mock/lib/MatchMediaMock.js
// module id = 232
// module chunks = 0